module.exports = __webpack_public_path__ + "media/images/tl/banner/id-2-light-16d45d7088a990ee676a902d8015b2d5.jpg";